module.exports = __webpack_public_path__ + "media/assets/svgs/logoDark-6ffc9a1f5ef31013744ea104c5c994c2.svg";